import { render, staticRenderFns } from "./collab_task_list.vue?vue&type=template&id=765e39e6&scoped=true"
import script from "./collab_task_list.vue?vue&type=script&lang=js"
export * from "./collab_task_list.vue?vue&type=script&lang=js"
import style0 from "./collab_task_list.vue?vue&type=style&index=0&id=765e39e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e39e6",
  null
  
)

export default component.exports